// This file was generated with `npm run icons:generate`. Don’t edit directly.
import Icon from 'styled/components/Icon/Icon';
import { IconOuterProps } from 'styled/components/Icon/Icon.types';

const UtilityMediumStrokeArrowLeftIcon = (props: IconOuterProps) => (
  <Icon {...props} size="medium">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5909 23.5835C8.35658 23.8178 8.35658 24.1977 8.5909 24.4321L18.3956 34.2367C18.6299 34.4711 19.0098 34.4711 19.2441 34.2367C19.4784 34.0024 19.4784 33.6225 19.2441 33.3882L10.4637 24.6078L39.0777 24.6078C39.409 24.6078 39.6777 24.3392 39.6777 24.0078C39.6777 23.6764 39.409 23.4078 39.0777 23.4078L10.4637 23.4078L19.2441 14.6274C19.4784 14.3931 19.4784 14.0132 19.2441 13.7788C19.0098 13.5445 18.6299 13.5445 18.3956 13.7788L8.5909 23.5835Z"
      fill="var(--icon-color-main)"
    />
  </Icon>
);

export default UtilityMediumStrokeArrowLeftIcon;
